import { Toaster } from "react-hot-toast";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./services/queryClient";

import Routes from "./pages/routes";
import "./App.css";
import { useEffect } from "react";
import { api } from "./services/api";
import { getUser, isMobileOS, isSupportedBrowser } from "./services/utils";
import { AppProvider } from "./services/app-context";
import { initializePostHog } from "./integrations/posthog/init";
import MobileBlockScreen from "./components/MobileBlockScreen";
import BrowserRequiredScreen from "./components/BrowserRequiredScreen";
import { LoggingErrorBoundary } from "./integrations/logger/ErrorBoundary";


function App() {

  const user = getUser();

  useEffect(() => {
    return () => {
      speechSynthesis.cancel();
    };
  }, []);

  const makeLastActive = async (userId: string) => {
    try {
      await api.saveLastActive(userId);
    } catch (error) {}
  };

  useEffect(() => {
    try {
      if (user?.id) {
        makeLastActive(user?.id);
      }
    } catch (error) {}
    return () => {
      try {
        if (user?.id) {
          makeLastActive(user?.id);
        }
      } catch (error) {}
    };
  }, [user?.id]);

  useEffect(() => {
    // Initialize PostHog
    initializePostHog();
  }, []);


  if (isMobileOS()) {
    return <MobileBlockScreen />;
  }

  if (!isSupportedBrowser()) {
    return <BrowserRequiredScreen />;
  }

  return (
    <LoggingErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AppProvider>
          <Toaster />
          <div className="min-h-screen flex flex-col">
            <Routes />
          </div>
        </AppProvider>
      </QueryClientProvider>
    </LoggingErrorBoundary>
  );
}

export default App;
